import(/* webpackMode: "eager" */ "/src/clients/web/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/src/clients/web/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/src/clients/web/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/src/clients/web/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager" */ "/src/clients/web/public/images/jobdetails/clock-solid.svg");
;
import(/* webpackMode: "eager" */ "/src/clients/web/public/images/jobdetails/exclamation-mark.png");
;
import(/* webpackMode: "eager" */ "/src/clients/web/public/images/jobdetails/money.png");
;
import(/* webpackMode: "eager" */ "/src/clients/web/public/images/searchresults/icon_location-pin.svg");
;
import(/* webpackMode: "eager" */ "/src/clients/web/src/app/[locale]/jobs/[location]/[microRole]/[title]/job-store.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/clients/web/src/app/[locale]/jobs/[location]/[microRole]/[title]/page-event.tsx");
;
import(/* webpackMode: "eager" */ "/src/clients/web/src/components/breadcrumb/breadcrumb-item/breadcrumb-item.module.scss");
;
import(/* webpackMode: "eager" */ "/src/clients/web/src/components/breadcrumb/breadcrumb.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/clients/web/src/components/buttons/button/button.tsx");
;
import(/* webpackMode: "eager" */ "/src/clients/web/src/components/job-card/ai-estimated-label/ai-estimated-label.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/clients/web/src/components/job-card/job-card.tsx");
;
import(/* webpackMode: "eager" */ "/src/clients/web/src/components/job-quick-info/job-quick-info.module.scss");
;
import(/* webpackMode: "eager" */ "/src/clients/web/src/components/job/ai-summary/ai-summary.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/clients/web/src/components/job/apply-banner/apply-banner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/clients/web/src/components/job/apply-disclaimer/apply-disclaimer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/clients/web/src/components/job/job-detail/header/apply-and-reminder.tsx");
;
import(/* webpackMode: "eager" */ "/src/clients/web/src/components/job/job-detail/header/expired-notice.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/clients/web/src/components/job/job-detail/job-additional-description.tsx");
;
import(/* webpackMode: "eager" */ "/src/clients/web/src/components/label/label.module.scss");
;
import(/* webpackMode: "eager" */ "/src/clients/web/src/components/job/job-detail/job-description.module.scss");
;
import(/* webpackMode: "eager" */ "/src/clients/web/src/components/job/similar-jobs/similar-jobs.module.scss");
;
import(/* webpackMode: "eager" */ "/src/clients/web/src/components/skeleton/skeleton.module.scss");
;
import(/* webpackMode: "eager" */ "/src/clients/web/src/components/job-extended-card/job-extended-card.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/clients/web/src/components/tooltip/tooltip.tsx");
